<template>
  <div class="footer" :style="{left: (showLeftMenu ? 272 : 64) + 'px'}">
    <!-- 左侧图标 -->
    <div class="footer-left">
      <el-tooltip class="item" effect="dark" content="导出" placement="top">
        <a href="javascript:;" @click="handleSelectExport" class="btn btn-hollow-dark btn-icon-only footer-btn-icon">
          <i class="mng icon-share-stroke"></i>
        </a>
      </el-tooltip>
      <el-tooltip v-if="showChartIcon" class="item" effect="dark" :content="showChart?'数据视图':'图表视图'" placement="top">
        <a href="javascript:;" @click="handleToggleChart" class="btn btn-hollow-dark btn-icon-only footer-btn-icon">
          <i :class="{'icon-tree-data-stroke': showChart}" class="mng icon-bars-stroke"></i>
        </a>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="删除记录" placement="top" v-if="isShowDeleteRecord">
        <a href="javascript:;" @click="toShowDeleteRecord" class="btn btn-hollow-dark btn-icon-only footer-btn-icon">
          <i class="mng icon-time-stroke"></i>
        </a>
      </el-tooltip>
    </div>

    <!--页码区域-->
    <div class="pagination-wrapper pagination-circle pagination-hover-solid text-center">
      <el-pagination
        @current-change="currentPageChange"
        :current-page="curPage"
        :page-size="myPageSize"
        :pager-count="5"
        layout="prev, pager, next"
        :total="totalCount">
      </el-pagination>
      <div class="pg-input">
        <span class="text">前往</span>
        <span><input
          @keyup.enter="jumpPage"
          type="number"
          class="form-control"
          v-model.number="jumpPageNumber"
          ></span>
        <span class="text">页</span>
      </div>
    </div>

    <!-- 右侧页数 -->
    <div class="footer-right">
      <div class="pagination-wrapper pagination-circle pagination-hover-solid">
        <div class="pg-total">
          <span class="text">共</span>
          <span class="num">{{ totalPage }}</span>
          <span class="text">页</span>
        </div>
        <div class="pg-total">
          <span class="text">共</span>
          <span class="num">{{ totalCount }}</span>
          <span class="text">条</span>
        </div>
        <div class="pg-select-wrap">
          <div class="pg-select" @click="showPageSizeSelect = !showPageSizeSelect">
            <i class="mng pg-select-arr" :class="[showPageSizeSelect ? 'icon-lineArrU-stroke' : 'icon-lineArrD-stroke']"></i>
            <div class="pg-select-result">显示{{ myPageSize }}条</div>
            <transition name="el-zoom-in-bottom">
              <div class="pg-select-list" v-show="showPageSizeSelect">
                <ul>
                  <li class="pg-select-li"
                      v-for="item in pageSizeOpts"
                      :class="{'pg-select-cur': item === myPageSize}"
                      @click="pageSizeChange(item)"
                  >显示{{ item }}条</li>
                </ul>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import util from '../../libs/util'

  export default {
    name: 'grid-footer',
    props: {
      curPage: { // 当前页
        type: Number,
        default: 1
      },
      pageSize: { // 页大小
        type: Number,
        default: 10
      },
      totalPage: { // 总页数
        type: Number,
        default: 1
      },
      totalCount: { // 记录总数
        type: Number,
        default: 0
      },
      pageSizeOpts: { // 每页条数切换配置
        type: Array,
        default() {
          return [10, 20, 50, 100, 200, 300, 500, 1000]
        }
      },
      showChartIcon: {
        type: Boolean,
        default: false
      },
      showChart: {
        type: Boolean,
        default: false
      },
      gridConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      magicalMenuCodes: {
        type: Array,
        default() {
          return null
        }
      },
      showDeleteRecord: {
        type: Boolean,
        default () {
          return undefined
        }
      }
    },
    data() {
      return {
        showPageSizeSelect: false,
        jumpPageNumber: null,
        curSize: this.pageSizeOpts[0]
      }
    },
    computed: {
      showLeftMenu: function () {
        return this.$store.state.app.showLeftMenu
      },
      myCurPage: function () {
        return this.curPage
      },
      myPageSize: function () {
        return this.pageSize
      },
      isShowDeleteRecord: function() {
        return this.showDeleteRecord !== undefined ? this.showDeleteRecord : this.magicalMenuCodes.indexOf('showDeleteRecord') >= 0
      },
      // 页面固定显示9页,计算最左页码与最右页码，不足9页的显示全部。
      pageNums: function () {
        let left
        let right
        let showPageNumItems = 5
        let median = Math.floor(showPageNumItems / 2)
        if (this.curPage - median <= 1) {
          left = 1
          right = left + showPageNumItems - 1
        } else if (this.curPage + median >= this.totalPage) {
          right = this.totalPage
          left = right - showPageNumItems + 1
        } else {
          left = this.curPage - median
          right = this.curPage + median
        }
        if (left < 1) {
          left = 1
        }
        if (right > this.totalPage) {
          right = this.totalPage
        }

        let pageArray = []
        // 将页码循环存入数组
        while (left <= right) {
          pageArray.push(left)
          left++
        }
        return pageArray
      }
    },
    methods: {
      jumpPage() {
        if (this.jumpPageNumber) {
          this.currentPageChange(this.jumpPageNumber)
        }
      },
      // 当前页改变时
      currentPageChange(curPage) {
        curPage = curPage > this.totalPage ? this.totalPage : curPage
        curPage = curPage < 1 ? 1 : curPage
        this.$emit('current-change', curPage)
      },
      // 页大小改变时
      pageSizeChange(pageSize) {
        this.$emit('size-change', pageSize)
      },
      handleToggleChart() {
        this.$emit('toggle-chart')
      },
      // 点击导出按钮
      handleSelectExport() {
        this.$emit('export')
      },
      getNamespace: function(code) {
        let menus = this.gridConfig.gridMenuList
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].type === 'magicalMenu') {
            let extendConfig = JSON.parse(menus[i].extendMenuConfig)
            if (extendConfig.code === code) {
              return extendConfig.namespace
            }
          }
        }
        return null
      },
      toShowDeleteRecord: function() {
        util.changeRouter(this, {
          name: 'showDeleteRecord',
          query: {
            namespace: this.getNamespace('showDeleteRecord')
          }
        })
      }
    }
  }
</script>
<style lang="scss">
.jump-page-wrapper {
  display: inline-block;

  input {
    height: 30px !important;
  }

  input[type=number] {
    -moz-appearance: textfield;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/grid/grid-footer.vue